import { Save } from "@mui/icons-material";
import { AlertColor, Box, Button, Divider, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../context/AuthProvider/useAuth";
import { useProfile } from "../../../context/ProfileProvider/useProfile";
import { Organization } from "../../../model/OrganizationModel";
import { EditUserMyData, GetUser } from "../../../services/UserServices";
import { useNavigate } from "react-router-dom";

export interface IHeaderMenuComponent {
    icon: JSX.Element;
    title: string;
    contentString: string;
    username?: string;
    organization?: Organization;
    isAdminOrganizationOrRead?: { isAdmin: boolean, isReader: boolean };
    loginType?: number;
    setUsername?: (set: string) => void;
    phone?: string;
    setNeedReload?: (set: boolean) => void;
    setPopupOk: (set: boolean) => void;
    setAlertColor: (set: AlertColor) => void;
    setMessage: (set: string) => void;
    index?: number;
}

export const HeaderMenuComponent: React.FC<IHeaderMenuComponent> = ({
    icon,
    title,
    contentString,
    username,
    organization,
    isAdminOrganizationOrRead,
    loginType,
    setUsername,
    phone,
    setNeedReload,
    setAlertColor,
    setMessage,
    setPopupOk,
    index
}) => {

    const { t } = useTranslation();
    const profile = useProfile();
    const auth = useAuth();
    const navigate = useNavigate();
    const editUserByData = () => {
        setNeedReload!(true);
        EditUserMyData({
            id: profile.id!,
            login: profile.login!,
            name: username,
            phone: phone,
        })
            .then(() => {
                setAlertColor("success");
                setMessage(t("MyData.UserEdittedSuccessfully"));
                setPopupOk(true);

                GetUser(profile.id!)
                    .then(data => {
                        profile.setUsername(data.name!);
                        profile.setUserphone(data.phone! != profile.phone! ? data.phone! : profile.phone!);
                    })
                    .catch(error => {
                        setAlertColor("error");
                        setMessage(error.response.data);
                        setPopupOk(true);
                    })
                    .finally(() => {
                        setNeedReload!(false);
                        profile.setHavePersonalDataModification(false);
                    })
            })
            .catch((error) => {
                setAlertColor("error");
                setMessage(error.response.data);
                setPopupOk(true);
            })
            .finally(() => {
                setNeedReload!(false);
                profile.setHavePersonalDataModification(false);
            })
    }

    return (
        <Grid item xs={12}>
            <Box
                display="flex"
                justifyContent="space-between"
            >
                <Box
                    display="flex"
                    alignItems="center"
                    gap={2}
                >
                    {icon}
                    <Typography
                        fontSize="20px"
                        fontFamily="Segoe UI"
                        color="#2D2D2D"
                    >
                        {title}
                    </Typography>
                </Box>
                <Box
                display="flex"
                    gap={2}
                >
                    { index !== 2 && (
                        <>
                            <Button
                                variant="contained"
                                sx={{
                                    background: "#FFFFFF",
                                    border: "1px solid #22638D",
                                    color: "#22638D",
                                    padding: "6px 10px",
                                    fontWeight: "normal",
                                    textTransform: "none",
                                    '&:hover': {
                                        background: "#FFFFFF"
                                    }
                                }}
                                onClick={()=>{navigate(-1)}}
                            >
                                {t("MyData.Cancel")}
                            </Button>
                        
                            <Button
                                variant="contained"
                                startIcon={<Save />}
                                sx={{
                                    background: "#22638D",
                                    padding: "6px 10px",
                                    fontWeight: "normal",
                                    textTransform: "none",
                                    '&:hover': {
                                        background: "#467ca0"
                                    },
                                    '&:disabled': {
                                        border: "1px solid #22638D",
                                        background: "#22638D",
                                        color: "#FFFFFF",
                                        opacity: 0.2
                                    }
                                }}
                                onClick={editUserByData}
                                disabled={!profile.havePersonalDataModification}
                            >
                                {t("MyData.Save")}
                            </Button>
                        </>
                    ) }
                </Box>
            </Box>
            <Box
                marginTop="10px"
            >
                <Typography
                    fontSize="14px"
                    color="#2D2D2D"
                    sx={{ opacity: .8 }}
                >
                    {contentString}
                </Typography>
            </Box>
            <Divider
                sx={{
                    marginTop: "20px",
                    opacity: .2,
                    borderColor: "#22638D",

                }}
            />
        </Grid>
    )
}